import React from 'react';
import {OPEN_MODAL, CLOSE_MODAL} from './modalTypes';
import {openMsg} from '../msg/msgActions';
import {dev} from 'lib.common';

export function closeModal() {
   return {
      type: CLOSE_MODAL
   };
}

export function openModal(
   Component,
   componentProps = {},
   callbackOnClose = null,
   containerProps = {}
) {
   return async function (dispatch) {
      const {open, onClose, children, ...options} = containerProps;
      async function handleCloseModalCallback(data) {
         try {
            if (callbackOnClose) {
               await callbackOnClose(data);
               dispatch(closeModal());
            } else {
               dispatch(closeModal());
            }
         } catch (error) {
            dispatch(openMsg(dev.getErrorMsg(error)));
         }
      }
      dispatch({
         type: OPEN_MODAL,
         payload: {
            ...options,
            onClose: handleCloseModalCallback,
            children: (
               <Component
                  closeModalCallback={handleCloseModalCallback}
                  closeModal={() => {
                     dispatch(closeModal());
                  }}
                  {...componentProps}
               />
            )
         }
      });
   };
}
